import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'

import { userActions } from 'reduxModules/actions/UserActions'
import { dataSelector } from 'reduxModules/selectors/ModalSelectors'
import { historySelector } from 'reduxModules/selectors/UserSelectors'

import { UserHistoryBase } from './UserHistory'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  data: dataSelector,
  history: historySelector,
})

const mapDispatchToProps = {
  getUserHistory: userActions.getUserHistory,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const UserHistory = enhance(UserHistoryBase)



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/UserHistory/index.js